(() => {
  const initialise = () => {
    const params = new URLSearchParams(location.search);
    const type = document.querySelector('#DRFType');
    if (type && params.has('project') && Array.from(type.options).some(option => option.value === params.get('project'))) type.value = params.get('project');
    const detail = document.querySelector('#DRFDetails');
    if (detail && params.has('item') && !detail.value) detail.value = 'Item: ' + params.get('item').slice(0,250) + '\n' + (params.get('options') || '').slice(0,300) + '\nQuantity: ' + (params.get('quantity') || '');
    const campaign = document.querySelector('[data-drf-campaign]');
    if (campaign) campaign.value = ['utm_source','utm_medium','utm_campaign'].filter(key => params.has(key)).map(key => key + '=' + params.get(key).slice(0,100)).join('; ');
    const source = document.querySelector('[data-drf-source]');
    if (source && /^\/(?!\/)[^?#]*$/.test(params.get('source_path') || '')) source.value = params.get('source_path').slice(0,300);
    document.querySelectorAll('a[href*="/pages/get-a-quote"]').forEach(link => {
      const target = new URL(link.href);
      if (target.origin !== location.origin) return;
      ['utm_source','utm_medium','utm_campaign'].forEach(key => { if (params.has(key)) target.searchParams.set(key,params.get(key).slice(0,100)); });
      if (location.pathname !== '/pages/get-a-quote') target.searchParams.set('source_path',location.pathname);
      link.href = target.pathname + target.search;
    });
    document.querySelectorAll('[data-drf-product-quote]').forEach(link => {
      if (link.dataset.bound) return;
      link.dataset.bound = 'true';
      link.addEventListener('click', () => {
        const selections = Array.from(document.querySelectorAll('[data-drf-option], variant-selects input:checked, variant-selects select')).map(input => input.value).join(' / ');
        const target = new URL(link.href);
        target.searchParams.set('options', selections);
        target.searchParams.set('quantity', document.querySelector('[data-drf-quantity]')?.value || document.querySelector('quantity-input input')?.value || '1');
        link.href = target.pathname + target.search;
      });
    });
    document.querySelectorAll('.drf-mobile-nav,.drf-nav-details').forEach(menu => {
      if (menu.dataset.bound) return;
      menu.dataset.bound = 'true';
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    });
    document.querySelectorAll('[data-drf-options]').forEach(group => {
      if (group.dataset.bound) return;
      group.dataset.bound = 'true';
      const variants = JSON.parse(group.querySelector('[data-drf-variants]').textContent);
      const media = JSON.parse(group.querySelector('[data-drf-media]').textContent);
      const update = () => {
        const selected = Array.from(group.querySelectorAll('[data-drf-option]')).map(input => input.value);
        const variant = variants.find(item => item.options.every((value,index) => value === selected[index]));
        const price = document.querySelector('[data-drf-quote-price]');
        if (variant && price) price.textContent = variant.price;
        const color = group.querySelector('[data-option-name="Color"]')?.value.toLowerCase();
        const image = color && media.find(item => (item.alt || '').toLowerCase().startsWith(color) || (item.alt || '').toLowerCase().includes('in ' + color));
        const gallery = document.querySelector('media-gallery');
        if (image && gallery?.setActiveMedia) gallery.setActiveMedia(group.dataset.section + '-' + image.id,false);
      };
      group.addEventListener('change', update);
      update();
    });
    const quoteForm = document.querySelector('#DRFQuote');
    if (quoteForm && !quoteForm.dataset.bound) {
      quoteForm.dataset.bound = 'true';
      quoteForm.addEventListener('submit', () => {
        try { sessionStorage.setItem('drf_pending_quote', JSON.stringify({ id: crypto.randomUUID(), is_test: document.querySelector('#DRFDetails')?.value.startsWith('INTERNAL WEBSITE TEST') || false, created: Date.now() })); } catch (_) {}
      });
    }
    const success = document.querySelector('[data-drf-quote-success]');
    if (success) {
      success.focus({preventScroll:true});
      try {
        const pending = JSON.parse(sessionStorage.getItem('drf_pending_quote') || 'null');
        if (pending && Date.now() - pending.created < 3600000 && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() && window.Shopify?.analytics?.publish) {
          sessionStorage.removeItem('drf_pending_quote');
          Promise.resolve(window.Shopify.analytics.publish('drf:quote_submitted', {form_id:'project_inquiry',event_id:pending.id,is_test:pending.is_test})).then(() => {success.dataset.drfAnalyticsStatus='published';}).catch(() => {success.dataset.drfAnalyticsStatus='unavailable';});
        }
      } catch (_) {}
    }
  };
  document.addEventListener('DOMContentLoaded', initialise);
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('visitorConsentCollected', initialise);
  window.addEventListener('load', initialise);
})();
